import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import BrandMark from "@/components/base/BrandMark";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/archive", label: "复盘档案", end: false },
  { to: "/about", label: "关于我们", end: false },
  { to: "/contact", label: "联系我们", end: false },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/92 backdrop-blur-md border-b border-background-200/80"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-content items-center justify-between px-4 md:px-6">
        <BrandMark />

        <nav
          aria-label="主导航"
          className="hidden items-center gap-1 rounded-full border border-background-200/70 bg-background-100/60 px-1 py-1 md:flex"
        >
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors duration-200 cursor-pointer ${
                  isActive
                    ? "bg-primary-600 text-foreground-950"
                    : "text-foreground-600 hover:text-foreground-950 hover:bg-background-200/70"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/archive"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2 text-sm text-foreground-700 transition-colors duration-200 hover:border-accent-400 hover:text-foreground-950 cursor-pointer"
          >
            <i className="ri-search-line text-base" />
            检索档案
          </Link>
          <Link
            to="/contact"
            className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-950 transition-colors duration-200 hover:bg-accent-400 cursor-pointer"
          >
            投稿线索
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          aria-expanded={menuOpen}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 md:hidden cursor-pointer"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/80 bg-background-50 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `flex items-center justify-between border-b border-background-200/60 py-3.5 text-base cursor-pointer ${
                    isActive ? "text-primary-400" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg" />
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setMenuOpen(false)}
              className="mt-4 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-3 text-sm font-medium text-background-950 cursor-pointer"
            >
              <i className="ri-pen-nib-line" />
              投稿线索
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}